module.exports = __webpack_public_path__ + "static/media/LinkedIn-Icon.9b6a82f9.png";